<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />

    <v-col lg="12" class="ml-auto"></v-col>
    <b-card header-bg-variant="primary" header-text-variant="white">
      <template v-slot:header>
        <h6>استعلام‌های آماده ارسال به کارخانه</h6>
        کد آخرین سفارش ابلاغ شده به کارخانه: {{ latestCode }}
      </template>

      <br />
      <div>
        <b-card class="shadow p-3 mb-5 bg-white rounded">
          <v-row class="pb-0 mt-3">
            <v-col cols="8">
              <v-text-field
                clearable
                v-model="filter"
                id="filterInput"
                placeholder="جستجو"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn
                class="darkGreen-mainBtn white--text float-end"
                @click="$refs.activeTable.$el.click()"
                depressed
                :disabled="!confirmedOrders.length"
                style="width: 135px; height: 35px"
              >
                <v-icon class="me-1"> mdi-file-excel-outline </v-icon>
                خروجی اکسل
              </v-btn>
              <vue-excel-xlsx
                ref="activeTable"
                :data="confirmedOrders"
                :columns="ExcelFields"
                :sheet-name="`استعلام‌های آماده`"
                :file-name="`استعلام‌های آماده ارسال به کارخانه`"
              ></vue-excel-xlsx>
            </v-col>
            <v-col cols="2">
              <v-btn
                :disabled="gettingReceipt || !confirmedOrders.length"
                class="darkRed-mainBtn white--text float-end"
                style="width: 135px; height: 35px"
                @click="printReceipt()"
                depressed
                ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
              >
            </v-col>
          </v-row>
          <b-table
            responsive
            show-empty
            id="confirmedOrdersTable"
            :items="confirmedOrders"
            :fields="fields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :current-page="currentPage"
            :per-page="perPage"
            :busy="isBusy"
            :filter="filter"
            @filtered="onfilter"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ perPage * (currentPage - 1) + data.index + 1 }}
              </div>
            </template>
            <template v-slot:cell(code)="data">
              <div style="text-align: center; vertical-align: middle">
                <a
                  :href="'/' + role + '/order/' + data.item.id"
                  target="_blank"
                  >{{ data.item.code }}</a
                >
                <span v-if="data.item.isUrgent" class="text-danger">
                  <i class="mr-1 fa fa-exclamation-triangle"> </i>
                  فوری
                </span>
              </div>
            </template>
            <template v-slot:cell(customerName)="data">
              <div style="text-align: center; vertical-align: middle">
                <a
                  :href="
                    '/' + role + '/customerProfile/' + data.item.customerId
                  "
                  >{{ data.item.customerName }}</a
                >
              </div>
            </template>
            <template v-slot:cell(operation)="row">
              <b-button
                v-if="row.item._showDetails"
                variant="danger"
                @click="row.toggleDetails"
                >بستن
              </b-button>
              <b-button v-else variant="primary" @click="row.toggleDetails"
                >عملیات
              </b-button>
            </template>

            <template #row-details="row">
              <div
                class="animated fadeIn"
                style="text-align: center; vertical-align: middle"
              >
                <a
                  class="btn btn-dark mr-1 mt-1"
                  :href="'/' + role + '/printPreview/' + 'full/' + row.item.id"
                  target="_blank"
                  role="button"
                  >استعلام مالی</a
                >
                <a
                  class="btn btn-dark mr-1 mt-1"
                  :href="
                    '/' + role + '/printPreview/' + 'technical/' + row.item.id
                  "
                  target="_blank"
                  role="button"
                  >استعلام فنی</a
                >
                <!-- <b-btn
                  class="mr-1 mt-1"
                  variant="success"
                  @click="sendToFactory(row.item)"
                  v-if="
                    role == 'Manager' ||
                    role == 'trade' ||
                    role == 'tradeHead' ||
                    role == 'salesManager'
                  "
                  >ارسال به کارخانه</b-btn
                > -->
                <a
                  class="btn btn-success mr-1 mt-1"
                  :href="'/' + role + '/sendToFactory/' + row.item.id"
                  target="_blank"
                  role="button"
                  v-if="
                    role == 'Manager' ||
                    role == 'trade' ||
                    role == 'tradeHead' ||
                    role == 'salesManager'
                  "
                  >ارسال به کارخانه</a
                >
                <b-btn
                  class="mr-1 mt-1"
                  variant="success"
                  @click="assignToMe(row.item)"
                  v-if="
                    row.item.assigneeName == '-' &&
                    role != 'secretary' &&
                    row.item.status != 'عدم' &&
                    row.item.status != 'آرشیو'
                  "
                  >تخصیص به من</b-btn
                >&nbsp;
                <b-btn
                  class="mr-1 mt-1"
                  variant="danger"
                  @click="removeAssignee(row.item)"
                  v-if="
                    row.item.assigneeName != '-' &&
                    role != 'secretary' &&
                    role != 'trade' &&
                    row.item.status != 'عدم' &&
                    row.item.status != 'آرشیو'
                  "
                  >حذف مجری</b-btn
                >&nbsp;
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="TotalRows"
            :per-page="perPage"
            aria-controls="confirmedOrdersTable"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>
          <!-- <vue-excel-xlsx
            v-if="confirmedOrders.length > 0 && role == 'Manager'"
            style="float: left"
            class="mb-3 btn-dark rounded p-2"
            :data="confirmedOrders"
            :columns="
              fields
                .map((y) => {
                  return {
                    label: y.label,
                    field: y.key,
                  };
                })
                .filter((x) => x.field != 'index')
            "
            :file-name="
              'سفارشات_' + moment(new Date()).format('jYYYY-jMM-jDD_HH_mm_ss')
            "
            :sheet-name="'سفارشات'"
            >خروجی اکسل</vue-excel-xlsx
          > -->
        </b-card>
      </div>

      <br />
    </b-card>
    <div id="printTable" v-show="false">
      <h3 class="text-right" style="float: right">
        استعلام‌های آماده ارسال به کارخانه
      </h3>
      <b-table :items="confirmedOrders" :fields="printfields">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../variables";
import moment from "moment-jalaali";
import router from "../router";

import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
   
  },
  data: function () {
    return {
      printInvoice: {},
      gettingReceipt: false,
      guide: false,
      selected: "",
      moment: moment,
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      uploadedFiles: [],
      selectedRequest: {},
      filter: "",
      fileFields: [
        { key: "send", label: "ارسال شود" },
        { key: "index", label: "#" },
        { key: "uploadDate", label: "تاریخ آپلود" },
        { key: "fileName", label: "نام فایل" },
        // { key: "subject", label: "توضیحات" },
        { key: "assignee", label: "فرد بارگذاری کننده" },
        { key: "download", label: "دریافت" },
      ],
      fields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "شماره پرونده" },
        { key: "requestId", label: "کد درخواست" },
        // { key: 'subject', label: 'عنوان استعلام' },
        { key: "customerName", label: "نام مشتری" },
        { key: "assigneeName", label: "کارشناس بازرگانی" },
        { key: "contactName", label: "نماینده مشتری" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      printfields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "شماره پرونده" },
        { key: "requestId", label: "کد درخواست" },
        { key: "customerName", label: "نام مشتری" },
        { key: "assigneeName", label: "کارشناس بازرگانی" },
        { key: "contactName", label: "نماینده مشتری" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "status", label: "وضعیت" },
      ],
      ExcelFields: [
        { field: "code", label: "شماره پرونده" },
        { field: "requestId", label: "کد درخواست" },
        { field: "customerName", label: "نام مشتری" },
        { field: "assigneeName", label: "کارشناس بازرگانی" },
        { key: "contactName", label: "نماینده مشتری" },
        { field: "registerDate", label: "تاریخ ثبت" },
        { field: "status", label: "وضعیت" },
      ],
      fields1: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "#" },
      ],
      fields2: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "#" },
      ],
      fieldsen: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "index", label: "#" },
      ],
      fieldsCI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "index", label: "#" },
      ],
      fields2CI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "index", label: "#" },
      ],
      fieldsenCI: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "index", label: "#" },
      ],

      currentPage: 1,
      perPage: 10,
      isBusy: false,
      TotalRows: 1,
      striped: true,
      uniqueValues: [],
      content: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },

      role: "",
      nextIndex: 0,
      newIndex: 0,
      showModal: false,
      confirmedOrders: [],
      latestCode: "-",
    };
  },

  methods: {
    print(item) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/ppkpms/orders/getInfo",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          setTimeout(() => {
            this.printReceipt();
          }, 400);
        })
        .catch((err) => {
          console.log(err);
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title></title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("printTable").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    onfilter(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showConfirmedOrders() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/orders/getByStatus",
        {
          status: "آماده ارسال به کارخانه",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.confirmedOrders = res.data;
            this.TotalRows = this.confirmedOrders.length;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.Busy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });

      Axios.post(
        this.baseUrl + "/ppkpms/orders/getLatestFactoryOrderCode",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.latestCode = Number(res.data.code);
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },

    removeAssignee(order) {
      Axios.post(
        this.baseUrl + "/ppkpms/order/removeAssignee",
        { orderId: order.id },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.showConfirmedOrders();
            const title = (
              <div>
                <h5>حذف مجری</h5>
                <span>.مجری با موفقیت حذف شد</span>
              </div>
            );
            this.toast(title, "success");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    assignToMe(order) {
      Axios.post(
        this.baseUrl + "/ppkpms/order/assignToMe",
        { orderId: order.id },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.showConfirmedOrders();
            const title = (
              <div>
                <h5>تخصیص به من</h5>
                <span>.با موفقیت انجام شد</span>
              </div>
            );
            this.toast(title, "success");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    closeFactoryModal() {
      this.selectedRequest = {};
      this.$refs["sendtoFactory"].hide();
    },
    upload(file) {
      if (!file) {
        return;
      }
      // NOTE (m-myUpload) to upload files
      this.myFile.showProgress = true;
      this.myFile.variant = "info";
      this.myFile.uploadPercentage = 0;
      this.myFile.isUploaded = false;
      this.myFile.uploadButDisable = true;
      var formData = new FormData();
      formData.append(file.name, file);

      Axios.post(this.baseUrl + "/ppkpms/uploads/private", formData, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
        onUploadProgress: ((progressEvent) => {
          this.myFile.uploadPercentage =
            Math.round((progressEvent.loaded * 100) / progressEvent.total) - 1;
        }).bind(this),
      })
        .then((d) => {
          if (d.status == 200) {
            this.myFile.isUploaded = true;
            this.myFile.uploadPercentage = 100;
            this.myFile.striped = false;
            this.myFile.variant = "success";
            this.myFile.uploadButDisable = false;
            this.uploadedFiles = d.data;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getProjectInfo() {
      // Axios.get(this.baseUrl + "/projects/pms.json", {
      //   headers: {
      //     "X-Redmine-API-Key": window.localStorage.api_key,
      //   },
      // })
      //   .then((res) => {
      //     try {
      //       this.nextIndex = res.data.project.custom_fields.filter(
      //         (x) => x.id == 197
      //       )[0].value;
      //     } catch (error) {
      //       this.nextIndex = 1;
      //     }
      //   })
      //   .catch((err) => {
      //     console.log("ERR: " + err);
      //   });
    },
    sendToFactory(order) {
      this.$router.push("/" + this.role + "/sendToFactory/" + order.id);
    },
  },

  mounted() {
    // this.getProjectInfo();
    // this.getTableInfo();
    this.showConfirmedOrders();
    this.role = window.localStorage.getItem("role");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
